import { rngUnit } from "../../utils/rng";
import type { CollectorLanding } from "../collectors/lanes";
import { dailyIgnitionMultiplier } from "../daily-ignition";
import type { CoreState } from "../runtime/types";
import type { OrbitForgeSave } from "../save/types";
import type { UpgradeEffects } from "../upgrades/effects";

export interface RewardResult {
  readonly payout: number;
  readonly multiplier: number;
  readonly critical: boolean;
  readonly nextRngState: number;
}

export function applyCoreReward(save: OrbitForgeSave, core: CoreState, landing: CollectorLanding, effects: UpgradeEffects): RewardResult {
  const polarityMultiplier = 1 + core.polarityCharge;
  const zoneMultiplier = Math.max(1, core.zoneMultiplier);
  const rareMultiplier = Math.max(1, core.rewardMultiplier);
  const streakMultiplier = core.countsAsProgress ? dailyIgnitionMultiplier(save) : 1;
  const combined = landing.appliedMultiplier * polarityMultiplier * zoneMultiplier * rareMultiplier * streakMultiplier;
  const baseValue = effects.coreBaseValue + core.bounceCount * effects.chargeValue;
  const payout = Math.ceil(baseValue * combined);
  const critRoll = rngUnit(save.rngState);
  const critical = effects.criticalChance > 0 && critRoll.value <= effects.criticalChance;
  const finalPayout = critical ? payout + Math.ceil(payout * (effects.criticalMultiplier - 1)) : payout;

  save.stats.Credits += finalPayout;
  if (core.countsAsProgress) {
    save.stats.TotalEarnedCredits += finalPayout;
    save.stats.DailyEarnedCredits += finalPayout;
    save.stats.WeeklyEarnedCredits += finalPayout;
    save.stats.TotalCoresCollected += 1;
    save.stats.DailyCoresCollected += 1;
    save.stats.WeeklyCoresCollected += 1;
    save.stats.BestMultiplier = Math.max(save.stats.BestMultiplier, Math.ceil(combined));
    save.stats.BestPolarityStack = Math.max(save.stats.BestPolarityStack, core.polarityStacks);
  }

  return {
    payout: finalPayout,
    multiplier: combined,
    critical,
    nextRngState: critRoll.state
  };
}
